module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('h6', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.SplitMergeSummary()
      }
    }
  }, [_c('b-badge', {
    attrs: {
      "variant": _vm.Status == 2 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.Status == 2 ? 'Container Details' : 'Split Activated'))])], 1), _vm._v(" "), _c('b-modal', {
    ref: "SplitMergeSummary-modal",
    attrs: {
      "id": "SplitMergeSummary-modal",
      "title": _vm.title + _vm.SM_jb_series,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.containerDetails.length > 0) ? _c('div', {
    staticClass: "col-md-12 row"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")])]), _vm._v(" "), _vm._l((_vm.containerDetails), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerNo))]), _vm._v(" "), _c('td', [(itm.splitedToOrMergedToAssigNo) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("Container Moved From :" + _vm._s(itm.fromSplitMergeAssignNo) + " to :\n                  " + _vm._s(itm.splitedToOrMergedToAssigNo) + " ("), (itm.isSplitedOrMergedNew == 1) ? _c('b', [_vm._v("\n                    Splited")]) : (itm.isSplitedOrMergedNew == 2) ? _c('b', [_vm._v(" Merged")]) : (itm.isSplitedOrMergedNew == 3) ? _c('b', [_vm._v("Moved")]) : _vm._e(), _vm._v(")\n                  Updated Date(" + _vm._s(itm.split_merge_date_time) + ")")]) : _vm._e()])])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideSplitMergeSummary
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9ce3d44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/splitmergeSummary.vue
// module id = 2861
// module chunks = 0